<template>
  <h1 style="font-size: 2.2em;">质量部更新化验表</h1>
  <div class="lab-sheet-uploader">
    <h2>化验表上传</h2>
    <!--可能还要考虑支持多文件选择进行上传-->
    <div class="button-row">
      <label class="custom-file-upload">
        <!--如果是相同文件不会触发 handleFileChange，也就无法点击上传按钮-->
        <input type="file" @change="handleFileChange" accept=".R3.pkg,.pkg" multiple />
        🔍 选择文件
      </label>
      <button class="upload-button" @click="uploadFile" :disabled="!selectedFile">
        ⬆️ 上传
      </button>
    </div>

    <div v-if="selectedFile && selectedFile.length" class="file-name">
      已选📄文件列表：
      <ul>
        <li v-for="file in selectedFile" :key="file.name" class="file-item">{{ file.name }}</li>
      </ul>
    </div>
  </div>

   <!-- ✅ 新增部分：显示已上传文件 -->
  <div v-if="uploadedFiles.length" class="uploaded-files">
  <h2>已上传化验表</h2>
  <table class="file-table">
    <thead>
      <tr>
        <th style="width: 80px;">ID</th>
        <th style="text-align: left;">文件名</th>
        <th style="width: 180px;">上传时间</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(file, index) in uploadedFiles" :key="file.name">
        <td>{{ index + 1 }}</td>
        <td class="filename">{{ file.name }}</td>
        <td>{{ formatDate(file.uploadTime) }}</td>
      </tr>
    </tbody>
  </table>
  </div>
</template>

<script>
import { showSuccess,showError,showInfo, showWarning } from '../utils';
import axios from 'axios';
const axiosInstance = axios.create({
    baseURL: 'https://relia-server.com:3000',
    timeout: 10000,
     withCredentials: true
});

export default {
  name: 'LabSheetUploader',
  mounted() {
    this.fetchUploadedFiles();
  },
  data() {
    return {
      selectedFile: null,
      uploadedFiles: [] // 这里是从服务器获取的上传文件
    };
  },
  methods: {
    handleFileChange(event) {
      this.selectedFile = Array.from(event.target.files);
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
    async fetchUploadedFiles() {
      try {
        const res = await axiosInstance.get('/api/list_lab_sheets');
        if (res.data.success) {
          this.uploadedFiles = res.data.data;
        } else {
          console.warn('获取上传文件列表失败:', res.data.message);
        }
      } catch (err) {
        console.error('请求上传文件列表出错:', err);
      }
  },
    async uploadFile() {
      if (!this.selectedFile || this.selectedFile.length === 0) {
        showWarning('请选择文件');
        return;
      }

      // 文件名格式正则（例如：[项目名称] - [9位数字串] .R3.pkg）
      const fileNamePattern = /^[\w\-]+-\d{9}\.R3\.pkg$/;

      // 最大文件大小限制，5MB
      const maxFileSize = 5 * 1024 * 1024;

      // 定义一个变量，记录总共多少个文件被上传，是否全部上传成功
      let uploadedCount = 0;

      // 过期时间 18 个月
      const expirationTime = 18 * 30 * 24 * 60 * 60 * 1000; 

      for (const file of this.selectedFile) {
        // 1. 文件名格式检查
        if (!fileNamePattern.test(file.name)) {
          showError(`${file.name} 文件名格式不符合要求，需要按格式：\n[项目名称]-[9位数字串].R3.pkg`);
          continue; // 跳过不符合格式的文件
        }

        // 2. 文件大小检查
        if (file.size > maxFileSize) {
          showError(`${file.name} 文件过大，请选择不超过 5MB 的文件`);
          continue; // 跳过超过大小限制的文件
        }

        // 3. 过期检查
        const base = file.name.slice(0, -12); // 去掉尾部的 .R3.pkg
        const now = Date.now();

        // 提取日期部分 yyMM
        const dateStr = base.slice(-4);
        const year = parseInt(dateStr.slice(0, 2), 10) + 2000; // 年份 + 2000
        const month = parseInt(dateStr.slice(2, 4), 10) - 1; // 月份从 0 开始

        // 创建日期对象
        const created_at = new Date(year, month, 1);

        // 仅当年份和月份合法时才进行过期判断
        if (isNaN(created_at.getTime())) {
          showError(`${file.name} 文件日期无效，无法解析文件日期`);
          continue; // 跳过日期无效的文件
        }

        console.log(`提取日期: ${dateStr} → 制作时间: ${created_at.toLocaleDateString()}`);

        // 比较当前时间和文件创建时间，判断文件是否过期
        if (now - created_at.getTime() > expirationTime) {
          showError(`${file.name} 文件已过期，请重新上传🚫`);
          continue; // 跳过过期文件
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
          const response = await axiosInstance.post('/api/upload_lab_sheet', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          if (response.data.success) {
            // 可以根据需要显示每个文件的上传结果
            showSuccess(`${file.name} 上传成功✅`);
            uploadedCount++;
          } else {
            showError(`${file.name} 上传失败: ` + (response.data.message || '未知错误'));
          }
        } catch (error) {
          console.error(`${file.name} 上传失败:`, error);
          showError(`${file.name} 上传失败，请检查网络或联系管理员`);
        }
      }
      console.log(`uploadedCount: ${uploadedCount}`)
      if(uploadedCount === this.selectedFile.length){
        showSuccess('全部文件上传完成');
      }else if(uploadedCount > 0){
        // 打印总共多少文件，实际上传成功的文件数量
        showWarning(`选择了 ${this.selectedFile.length} 个文件，其中成功上传 ${uploadedCount} 个`);
      }

      this.selectedFile = null; // 上传成功后清空已选文件
      this.fetchUploadedFiles();// 重新获取已上传文件列表
    }
  }
};
</script>

<style scoped>
.lab-sheet-uploader {
  padding: 20px;
  max-width: 400px;
  margin: auto;
  text-align: center;
  font-family: Arial, sans-serif;
}

.button-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.custom-file-upload {
  display: inline-block;
  padding: 14px 24px;
  font-size: 16px;
  cursor: pointer;
  background-color: #4CAF50;
  color: white;
  border-radius: 6px;
  transition: background-color 0.3s ease;
}

.custom-file-upload:hover {
  background-color: #45a049;
}

.custom-file-upload input[type="file"] {
  display: none;
}

.file-name {
  list-style-type: none; /* 移除默认的列表项符号 */
  padding: 0;
  margin-bottom: 30px;
  font-size: 24px;
  color: #333;
  margin-top: 30px; /* 增加与上方的空白距离 */
}

.file-item {
  font-size: 22px;
  text-align: left;
  color: #007BFF; /* 设置文件名为蓝色 */
  margin: 5px 0; /* 文件名之间的间距 */
  padding-left: 3em; /* 向左对齐但空出三格 */
}

.upload-button {
  padding: 14px 28px;
  font-size: 16px;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.upload-button:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.upload-button:hover:enabled {
  background-color: #1976D2;
}

.uploaded-files {
  margin-top: 40px;
  text-align: center;
}

.file-table {
  margin: auto;
  border-collapse: collapse;
  width: 100%;
  max-width: 800px;
}

.file-table th,
.file-table td {
  border: 1px solid #ccc;
  padding: 10px 12px;
  word-break: break-all;
  font-size: 15px;
}

.file-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.filename {
  text-align: left;
}

</style>
